import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useFileDownload } from '@/hooks/useFileDownload';
import { RenderType } from './RenderType';
import styles from './ChatEvent.module.scss';
export const Attachments = ({ id, filename, title, url, type, hasText, }) => {
    const { handleFileDownload } = useFileDownload();
    const [isDownloading, setIsDownloading] = useState(false);
    useEffect(() => {
        if (!url) {
            handleFileDownload(id, filename, title);
            if (type === 'image') {
                setIsDownloading(true);
            }
        }
    }, [filename, handleFileDownload, id, url, type, title]);
    const handleImageLoad = useCallback(() => {
        setIsDownloading(false);
    }, []);
    return (_jsx("div", { className: cn(styles.attachment, {
            [styles.hasText]: hasText,
            [styles.isDownloading]: isDownloading && type === 'image',
        }), children: _jsx(RenderType, { type: type, url: url, title: title, isDownloading: isDownloading, handleImageLoad: handleImageLoad }) }));
};
